var map = {
	"./b-campus-wh.svg": "1f18",
	"./b-play-wh.svg": "547f",
	"./banana-mobile-wh.svg": "b6b1",
	"./banana-outlet-wh.svg": "baa1",
	"./banana-wh.svg": "4f2b",
	"./bb-wh.svg": "73f6",
	"./bkk-wh.svg": "82e2",
	"./com7-wh.svg": "28a5",
	"./e-quip-wh.svg": "e54f",
	"./huawei-wh.svg": "2ef9",
	"./kkp-wh.svg": "83a1",
	"./oppo-wh.svg": "7940",
	"./realme-wh.svg": "1005",
	"./samsung-wh.svg": "1371",
	"./studio-7-wh.svg": "fdff",
	"./vivo-wh.svg": "c8fe",
	"./xiaomi-wh.svg": "67ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9673";